'use strict';

import settings from '../settings';
import store from '../store';
import { AppStoreTypes } from '../store/modules/app';
import { HttpContext } from '../utils/httpContext';

class AppService {
  async GetSzervezetek() {
    const url = settings.baseUrl + 'Api/App/GetSzervezetek';
    const result = await HttpContext.post({ url });
    store.dispatch(AppStoreTypes.szervezetek.set, { value: result });
    return result;
  }
}

let instance = new AppService();
export { instance as appService };
